import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "fill", "fill-opacity", "stroke", "stroke-width", "stroke-opacity"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.5 9H14.5C14.5 7.67392 13.9732 6.40215 13.0355 5.46447C12.0979 4.52678 10.8261 4 9.5 4V6C10.2956 6\n      11.0587 6.31607 11.6213 6.87868C12.1839 7.44129 12.5 8.20435 12.5 9ZM16.5 9H18.5C18.5 4 14.47 0 9.5 0V2C13.36\n      2 16.5 5.13 16.5 9ZM17.5 12.5C16.25 12.5 15.05 12.3 13.93 11.93C13.58 11.82 13.19 11.9 12.91 12.18L10.71\n      14.38C7.88 12.94 5.56 10.62 4.12 7.79L6.32 5.59C6.6 5.31 6.68 4.92 6.57 4.57C6.2 3.45 6 2.25 6 1C6 0.734784\n      5.89464 0.48043 5.70711 0.292893C5.51957 0.105357 5.26522 0 5 0H1.5C1.23478 0 0.98043 0.105357 0.792893\n      0.292893C0.605357 0.48043 0.5 0.734784 0.5 1C0.5 5.50868 2.29107 9.8327 5.47918 13.0208C8.6673 16.2089 12.9913\n      18 17.5 18C17.7652 18 18.0196 17.8946 18.2071 17.7071C18.3946 17.5196 18.5 17.2652 18.5 17V13.5C18.5 13.2348\n      18.3946 12.9804 18.2071 12.7929C18.0196 12.6054 17.7652 12.5 17.5 12.5Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneCallLogo',
  props: {
  fillColor: {
    type: String,
    default: 'white',
  },
  fillOpacity: {
    type: Number,
    default: 1,
  },
  strokeColor: {
    type: String,
    default: 'white',
  },
  strokeWidth: {
    type: Number,
    default: 1,
  },
  strokeOpacity: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 18,
  },
  width: {
    type: Number,
    default: 19,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 19 18",
    width: __props.width,
    height: __props.height,
    fill: __props.fillColor,
    "fill-opacity": __props.fillOpacity,
    stroke: __props.strokeColor,
    "stroke-width": __props.strokeWidth,
    "stroke-opacity": __props.strokeOpacity,
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})